const VERSION = "5.2.0";
export {
  VERSION
};
